export default "__VITE_ASSET__D3HOy2hK__"